import { observer } from 'mobx-react-lite'
import { SpinnerLoader } from 'shared/ui'
import { StepsCommonLayout } from 'pages/settings/ui/StepsCommonLayout/StepsCommonLayout'
import { useAddNumbersContext } from 'pages/settings/pages/inboxes/pages/id/pages/numbers/context/addNumbersContext'

export const AddNumberLayout = observer(() => {
  const { initialLoading, redirectToNumbers } = useAddNumbersContext()

  if (initialLoading) {
    return <SpinnerLoader ariaLabel={'AddNumberLayout'} />
  }

  return (
    <StepsCommonLayout
      title='Add number'
      progressTitle='How do you want to add a number?'
      settingsStep={1}
      totalSteps={1}
      closeSetting={redirectToNumbers}
    />
  )
})
